import React from "react";
import styles from "./TotalAnimalTable.module.css";

interface AnimalData {
  key: number;
  animal: string;
  count: number;
}

const dataSource: AnimalData[] = [
  {
    key: 1,
    animal: "Птицы",
    count: 6368695,
  },
  {
    key: 2,
    animal: "КРС",
    count: 1783469,
  },
  {
    key: 3,
    animal: "Коровы",
    count: 885673,
  },
  {
    key: 4,
    animal: "Лошади",
    count: 533979,
  },
  {
    key: 5,
    animal: "Овцы и Козы",
    count: 6200961,
  },
  {
    key: 6,
    animal: "Свиньи",
    count: 25640,
  },
];

export const TotalAnimalTable: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.container_inner}>
        <h2>Данные по животным</h2>
        <ul className={styles.table}>
          <li className={styles.header}>
            <span className={styles.cell}>Вид животного</span>
            <span className={styles.cell}>Данные по республике</span>
          </li>
          {dataSource.map((item) => (
            <li key={item.key} className={styles.row}>
              <span className={styles.cell}>{item.animal}</span>
              <span className={styles.cell}>{item.count.toLocaleString()}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};


